<template>

	<v-btn
		class="my-2"
		:loading="progress"
		:disabled="progress"
		color="success"
		v-bind="$attrs"
		x-large
		type="submit"

	>
		<slot>{{$t('attributes.save')}}</slot>
		<template v-slot:loader>
			<span class="custom-loader">
				<v-icon light>cached</v-icon>
			</span>
		</template>
	</v-btn>
</template>

<script>
	export default {
		name: "btn-loader",
		props: {
			progress: {
				default: false
			},
			icon: {
				default: "cached"
			}
		}
	};
</script>

<style>
	.custom-loader {
		animation: loader 1s infinite;
		display: flex;
	}
	@-moz-keyframes loader {
		from {
			transform: rotate(0);
		}
		to {
			transform: rotate(360deg);
		}
	}
	@-webkit-keyframes loader {
		from {
			transform: rotate(0);
		}
		to {
			transform: rotate(360deg);
		}
	}
	@-o-keyframes loader {
		from {
			transform: rotate(0);
		}
		to {
			transform: rotate(360deg);
		}
	}
	@keyframes loader {
		from {
			transform: rotate(0);
		}
		to {
			transform: rotate(360deg);
		}
	}
</style>
